import { Header } from 'components/molecules';
import { ListAMTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const ListBotPage = () => {
  return (
    <>
      <Header
        title="Automation Managers"
        subtitle="Administra tus AM"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <ListAMTemplate />
    </>
  );
};

export default withAuth(ListBotPage, undefined, 'mayasoft');
